<template>
  <a @click="onexport()" class="button is-primary tailleBtn">
    <b-icon class="icon_collapse"
      icon="file-excel">
    </b-icon>
    <span>Exporter</span>
  </a>
</template>

<script>
import XLSX from 'xlsx';

export default {
  props: ['liste'],
  data: () => ({
    datas: {},
  }),
  computed: {
    show() {
      if (Array.isArray(this.liste.data) && this.liste.data.length) {
        return true;
      }
      return false;
    },
    fileName() {
      if (this.liste.type === 'faceLc') return 'Liste Face Lc.xlsx';
      if (this.liste.type === 'reseauxTempo') return 'Liste Reseaux Tempo.xlsx';
      if (this.liste.type === 'reseauxLc') return 'Liste Reseaux Lc.xlsx';
      if (this.liste.type === 'faceNum') return 'Liste Face Numerique.xlsx';
      if (this.liste.type === 'reseauxNum') return 'Liste Reseaux Numerique.xlsx';
      if (this.liste.type === 'panneauxNoGeo') return 'Liste des panneaux non géo.xlsx';
      if (this.liste.type === 'panneauxNoAttach') return 'Liste des faces sans photo.xlsx';
      return '';
    },
    listeData() {
      if (this.liste.type === 'faceLc') {
        const data = [];
        this.liste.data.forEach((el) => {
          data.push({
            'Code Panneau': el.panCode,
            'Code Face': el.facCode,
            Propals: el.nbPropositions,
            Materiel: el.materiel,
            Adresse: el.adresse,
            'Code Postal': el.codePostal,
            Ville: el.ville,
            Departement: el.departement,
            Restrictions: el.restrictions,
            'Affectation LC': el.affLc,
            'Affectation Reseaux': el.affReseaux,
          });
        });
        return data;
      }
      if (this.liste.type === 'reseauxTempo') {
        const data = [];
        this.liste.data.forEach((el) => {
          data.push({
            Code: el.code,
            Libelle: el.libelle,
            Departement: el.depCode,
            Ville: el.ville,
            'Nb Faces prevues': el.nbFaces,
            Type: el.type,
            Confrere: el.confrere,
            Format: el.format,
            'Tarif brut': el.tarifBrutString,
            'Duree (semaine)': el.dureeConservation,
            'Jour depart': el.jourDepartLibelle,
          });
        });
        return data;
      }
      if (this.liste.type === 'reseauxLc') {
        const data = [];
        this.liste.data.forEach((el) => {
          data.push({
            Libelle: el.libelle,
            Departement: el.depCode,
            Ville: el.ville,
            'Nb Faces': el.nbFaces,
            Type: el.type,
            Format: el.format,
            'Tarif brut': el.tarifBrutString,
          });
        });
        return data;
      }
      if (this.liste.type === 'faceNum') {
        const data = [];
        this.liste.data.forEach((el) => {
          data.push({
            'Code Panneau': el.code,
            'Code Face': el.codeFaces,
            Materiel: el.materiel,
            Adresse: el.adresseCommercialeLibelle1,
            'Code Postal': el.codePostal,
            Ville: el.ville,
            Departement: el.departement,
            Restrictions: el.restrictions,
          });
        });
        return data;
      }
      if (this.liste.type === 'reseauxNum') {
        const data = [];
        this.liste.data.forEach((el) => {
          data.push({
            Code: el.code,
            Libelle: el.libelle,
            Departement: el.depCode,
            Ville: el.ville,
            'Nb Faces prevues': el.nbFaces,
            Type: el.type,
            Confrere: el.confrere,
            Format: el.format,
            'Tarif brut': el.tarifBrutString,
            'Duree (semaine)': el.dureeConservation,
            'Jour depart': el.jourDepartLibelle,
          });
        });
        return data;
      }
      if (['panneauxNoGeo', 'panneauxNoAttach'].includes(this.liste.type)) {
        return this.liste.data.map(el => {
          const adresse = [];
          if (el.adresseCommercialeLibelle1) adresse.push(el.adresseCommercialeLibelle1);
          if (el.adresseCommercialeLibelle2) adresse.push(el.adresseCommercialeLibelle2);
          if (el.adresseCommercialeLibelle3) adresse.push(el.adresseCommercialeLibelle3);
          return {
            'Code Panneau': el.code,
            'Code face': el.faces.map(fac => fac.facCode).join(', '),
            Format: el.format,
            Materiel: el.materiel,
            Adresse: adresse.join(', '),
            'Code Postal': el.codePostal,
            Ville: el.ville,
            'Code Departement': el.codeDepartement,
          };
        });
      }
      return null;
    },
  },
  methods: {
    onexport() {
      if (this.listeData.length) {
        const listeWS = XLSX.utils.json_to_sheet(this.listeData);

        const wb = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(wb, listeWS, this.fileName.split('.')[0]);

        XLSX.writeFile(wb, this.fileName);
      }
    },
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/exportExcel.vue